import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "d2-ic_drag",
  "use": "d2-ic_drag-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"d2-ic_drag\"><path d=\"M409.6 716.8v102.4H307.2v-102.4h102.4z m307.2 0v102.4h-102.4v-102.4h102.4zM409.6 460.8v102.4H307.2V460.8h102.4z m307.2 0v102.4h-102.4V460.8h102.4zM409.6 204.8v102.4H307.2V204.8h102.4z m307.2 0v102.4h-102.4V204.8h102.4z\" p-id=\"23501\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol